let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kHOMt"), load("5TCys")]).then(() => parcelRequire('1wIcl'));